export default __webpack_public_path__ + "static/media/closet1-1024w.c3f2e1e1.avif";